import { getRegionalisedLink } from './get-regionalised-link';

export function getRegionalisedQrCodeLink(
  link: string,
  version?: string | null
) {
  const regionalisedLink = getRegionalisedLink(link);

  const url = new URL(regionalisedLink);
  url.searchParams.set('qr', 'true');
  if (version && version !== '') {
    url.searchParams.set('version', version);
  }

  return url.toString();
}
